'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'milestone', 'MilestoneService', 'ModalService', '$security', 'StatusService',
    function ($scope, $modalInstance, milestone, MilestoneService, ModalService, $security, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.uniqueName = true;
            // копирование
            $scope.milestone = angular.copy(milestone);

            // Определение заголовка модального окна
            if (milestone == null || milestone.id == null) {
                $scope.title = "Создание нового статуса проекта";
                $scope.edit = true;
            } else {
                $scope.title = 'Редактирование статуса проекта "' + milestone.name + '"';
                $scope.edit = true;
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.milestone.status) {
                    $scope.milestone.status = data._embedded;
                }
            });
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                MilestoneService.api.exists({
                    filters: (($scope) => {
                        let filters = [];
                        filters.push("'name' EQ '" + $scope.milestone.name + "'");
                        if ($scope.milestone.id) {
                            filters.push("'id' NE '" + $scope.milestone.id + "'");
                        }
                        return filters;
                    })($scope)
                }, (data) => {
                    $scope.uniqueName = !data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        /**
         * Success
         */
        function ok() {
            $modalInstance.close($scope.milestone);
        }

        /**
         * Dismiss
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/src-categories');
        }

        // endregion

    }];